module.exports = __webpack_public_path__ + "static/media/empty-state-workpacks.bf358438.svg";